import { Box, Typography, Grid, Button } from "@mui/material";
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import { IDiscount, IPrices } from "../models";
import { WorkspacePremiumOutlined } from "@mui/icons-material";
import { useState } from "react";
import TimezoneChip from "components/TimezoneChip";

export interface CoursePlanProps {
  highlightedName: string;
  discountRate: IDiscount;
  listed_price: number;
  timeZone: 0 | 1 | 2;
  popularity: number | null;
  prices: IPrices[];
}

function CoursePlan(props: CoursePlanProps) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const totalPages = Math.ceil(props.prices.length / itemsPerPage);

  const currentItems = Array.from(
    { length: itemsPerPage },
    (_, index) => props.prices[startIndex + index] || {}
  );

  while (currentItems.length < itemsPerPage) {
    currentItems.push({
      time: "",
      price: 0,
    });
  }

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <Box
      borderTop={1}
      marginTop={3}
      paddingTop={1}
      paddingBottom={5}
      sx={{ borderTopStyle: "dashed" }}
    >
      <Grid container display="flex" width="100%" alignItems="end">
        <Grid item xs={8} display="flex" flexDirection="column">
          <Box display="flex" alignItems="center" py={1}>
            <TimezoneChip value={props.timeZone} />

            {props.popularity && (
              <>
                <WorkspacePremiumOutlined style={{ color: "#feca2f" }} />
                <Typography fontWeight="bold" color="#0060df">
                  人気 No.1
                </Typography>
              </>
            )}
          </Box>
          <Typography variant="body2" fontWeight="bold">
            {props.highlightedName}
          </Typography>
        </Grid>

        <Grid item xs={4} position="relative">
          <Grid container>
            {currentItems.map((item, index) => (
              <Grid
                item
                xs={4}
                px={1}
                key={index}
                display="flex"
                justifyContent="center"
              >
                {item.time && (
                  <Button
                    variant="contained"
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <Typography variant="body1" fontWeight="bold">
                      {item.time}
                    </Typography>
                    <Typography variant="body2" sx={{ width: "max-content" }}>
                      {item.price.toLocaleString()} 円
                    </Typography>
                  </Button>
                )}
              </Grid>
            ))}
          </Grid>

          <Box
            position="absolute"
            left={2}
            bottom="-75%"
            width="33.33%"
            border={1}
            borderRadius={2}
            borderColor="divider"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              cursor: "pointer",
              "&:hover": {
                bgcolor: "divider",
                color: "white",
              },
              opacity: currentPage === 1 ? 0.3 : 1,
              pointerEvents: currentPage === 1 ? "none" : "auto",
            }}
            onClick={goToPreviousPage}
          >
            <ArrowLeftIcon />
          </Box>

          <Box
            position="absolute"
            right={2}
            bottom="-75%"
            width="33.33%"
            border={1}
            borderRadius={2}
            borderColor="divider"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              cursor: "pointer",
              "&:hover": {
                bgcolor: "divider",
                color: "white",
              },
              opacity: currentPage === totalPages ? 0.3 : 1,
              pointerEvents: currentPage === totalPages ? "none" : "auto",
            }}
            onClick={goToNextPage}
          >
            <ArrowRightIcon />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CoursePlan;
